<template>
	<div class="references">
		<b-container class="container-lg mt-top text-left prl-outside">
			<b-row class="mb-3 top-text">{{$t('title')}}</b-row>
			<p class="mb-4 text-left">
				{{$t('titleText')}}
			</p>
			<b-row class="m-0">
			<b-col cols="12" v-for="(ref, key) in references" :key="key" class="p-0 pt-3 pb-3 bt-gera">
				<div class="ref-text float-left">
					<h5>{{ref.title}}</h5>
					<p>{{ref.text}}</p>
				</div>
				<div v-if="ref.pictures" class="image-list">
					<div v-for="(pic, key) in ref.pictures" :key="key" class="p-0 m-0 ref-pic" :class="(key!=0)?'mr-4':''" :title="$t('showbigpic')" @click="openPicture(ref.pictures, (ref.copyright)?ref.copyright:'', key)">
						<div class="hotspot p-0 m-0"><img src="@/assets/img/Referenzen_Overlay.png" /></div>
						<img :src="require(`@/assets/img/references/${pic}`)" />
					</div>
				</div>
			</b-col>
			<b-col cols="12" class="p-0 pb-3 bg-white">
				<b-row v-for="(ref,key) in references_nopic" :key="key" class="ref-bottom pt-3" :class="(key==0)?'ref-top':''">
					<b-col cols="6"><p>{{ref.title}}</p></b-col>
					<b-col cols="6"><p>{{ref.text}}</p></b-col>
				</b-row>
			</b-col>
			</b-row>
		</b-container>
		<div class="big-text text-left">Referenzen</div>
		<app-modal-galery v-if="overlayVisible"
			picFolder="references/"
			:pictures="pictures"
			:startPictureIndex="selPicIndex"
			:copyright="copyright"
			@closePicGalery="overlayVisible=false"
		/>

	</div>
</template>

<script>
import appModalGalery from '@/components/ModalGalery.vue';
export default {
	name: 'References',
	components: {
		appModalGalery
	},
	data () {
		return {
			overlayVisible: false,
			selectedPicture: null,
			pictures: null,
			copyright: '',
			selPicIndex: 0,
			references: [ // , pictures: ['references//'] },
				{ title: this.$t('r22'), text: this.$t('r22t'), pictures: ['Luxusyachten/Web-Al-Lusail-Tom-van-Oossanen-454.jpg','Luxusyachten/Web-Dilbar-Charl-van-Rooy-97918.jpg','Luxusyachten/Web-Lady-Gulya-Tom-van-Oossanen-83314.jpg','Luxusyachten/Web-Nord-Charl-van-Rooy-178903.jpg'] },
				{ title: this.$t('rn36'), text: this.$t('rn36t'), pictures: ['Haus der Musik Innsbruck/Atmos Haus der Musik_1.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik_2.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik_3.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik-Grosser Saal_1.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik-Grosser Saal_2.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik-Grosser Saal_3.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik-Grosser Saal_4.jpg','Haus der Musik Innsbruck/Atmos Haus der Musik-Kleiner Saal_1.jpg'] },
				{ title: this.$t('rn10'), text: this.$t('rn01t'), pictures: ['Kitzbuehel Kitzhof/Hotel Kitzhof_Zimmer-Suiten-Studios_1.jpg','Kitzbuehel Kitzhof/Hotel Kitzhof_Zimmer-Suiten-Studios_2.jpg','Kitzbuehel Kitzhof/Hotel Kitzhof_Zimmer-Suiten-Studios_3.jpg','Kitzbuehel Kitzhof/Hotel Kitzhof_Zimmer-Suiten-Studios_4.jpg','Kitzbuehel Kitzhof/Hotel Kitzhof_Zimmer-Suiten-Studios_5.jpg'] },
				{ title: this.$t('rn39'), text: this.$t('rn39t'), pictures: ['Bad Ragaz/BadRagaz_Quellenhof_1.jpg','Bad Ragaz/BadRagaz_Quellenhof_2.jpg','Bad Ragaz/BadRagaz_Quellenhof_3.jpg','Bad Ragaz/BadRagaz_Quellenhof_4.jpg'] },
				{ title: this.$t('r20'), text: this.$t('r20t'), pictures: ['MO Wien Staatsoper (c) Motel One/MotelOne_Wien-Staatsoper_MotelOne_1.jpg','MO Wien Staatsoper (c) Motel One/MotelOne_Wien-Staatsoper_MotelOne_2.jpg','MO Wien Staatsoper (c) Motel One/MotelOne_Wien-Staatsoper_MotelOne_3.jpg'], copyright: this.$t('r20c') },
				{ title: this.$t('r21'), text: this.$t('r21t'), pictures: ['MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_1.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_2.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_3.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_4.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_5.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_6.jpg','MO Zurich (c) Motel One/MotelOne_Zuerich_MotelOne_7.jpg'], copyright: this.$t('r21c') },
				{ title: this.$t('r01'), text: this.$t('r01t'), pictures: ['GERA_Ref1_1.png'] },
				{ title: this.$t('r02'), text: this.$t('r02t'), pictures: ['Mövenpick Hotel Paris/38a)Mövenpick Hotel Paris.jpg','Mövenpick Hotel Paris/38b)(Mövenpick Hotel Paris) Montage der gesamten Gästezimmer.jpg'] },
				{ title: this.$t('r03'), text: this.$t('r03t'), pictures: ['GERA_Ref3_1.jpg','GERA_Ref3_2.jpg','GERA_Ref3_3.jpg'] },
				{ title: this.$t('r04'), text: this.$t('r04t'), pictures: ['Ritz Carlton Hotel/28a)Ritz Carlton Hotel.jpg','Ritz Carlton Hotel/28b)(Ritz Carlton Hotel)Montage von über 380 Zimmer und Suiten.jpg'] },
				{ title: this.$t('r05'), text: this.$t('r05t'), pictures: [ 'Schlosshotel Velden/14Dresden.jpg', 'Schlosshotel Velden/10a)Schlosshotel- Velden.jpg', 'Schlosshotel Velden/10b)(Schlosshotel Velden)Montage von über 100 Suiten.jpg' ] },
				{ title: this.$t('r06'), text: this.$t('r06t'), pictures: ['Hotel Dominican/36b)Hotel Dominican-Montage der öffentlichen Bereiche.jpg', 'Hotel Dominican/36c)(Hotel Dominican)Montage von über 200 Gästezimmer.jpg'] },
				{ title: this.$t('r07'), text: this.$t('r07t'), pictures: ['NH Hotel Frankfurt/15a)NH Hotel.jpg','NH Hotel Frankfurt/17a)NH Hotel-Frankfurt.jpg', 'NH Hotel Frankfurt/17b)(NH Hotel Frankfurt) Montage der Gästezimmer und öffentlichen Bereiche.jpg', 'NH Hotel Frankfurt/15b)(NH Hotel)Montage von über 280 Zimmer.jpg'] },
				{ title: this.$t('r08'), text: this.$t('r08t'), pictures: ['NH Hotel Frankfurt/19a)NH Hotel.jpg', 'NH Hotel Frankfurt/19b)(NH Hotel)Montage von über 300 Gästezimmer.jpg'] },
				{ title: this.$t('r09'), text: this.$t('r09t'), pictures: ['Mercatorhalle Duisburg/20a)Mercatorhalle in Duisburg.jpg', 'Mercatorhalle Duisburg/20b)(Mercatorhalle in Duisburg).jpg'] },
				{ title: this.$t('r10'), text: this.$t('r10t'), pictures: ['Kanzleramt/25a)Kanzleramt.jpg', 'Kanzleramt/25b)(Kanzleramt) Einrichtung.jpg'] },
				{ title: this.$t('r11'), text: this.$t('r11t'), pictures: ['Alsenblöcke Berlin/27)Alsenblöcke Berlin-Montage von Wandverkleidungen in über 50 Sitzungssälen.jpg'] },
				{ title: this.$t('r12'), text: this.$t('r12t'), pictures: ['Auswärtiges Amt/26a)Auswärtiges Amt.jpg', 'Auswärtiges Amt/26b)(Auswärtiges Amt) Montage von über 1500 Büros.jpg'] },
				{ title: this.$t('r13'), text: this.$t('r13t'), pictures: ['Reichstag Berlin/24a)Reichstag.jpg', 'Reichstag Berlin/24b)(Reichstag) Einrichtung Plenarsaal.jpg'] },
				{ title: this.$t('r14'), text: this.$t('r14t'), pictures: [ 'Elbphilharmonie/AdobeStock_240411596.jpeg', 'Elbphilharmonie/_DSC4925.jpg', 'Elbphilharmonie/_DSC4836.jpg', 'Elbphilharmonie/_DSC5057.jpg', 'Elbphilharmonie/_DSC5086.jpg' /* 'Elbphilharmonie/_DSC4750.jpg', 'Elbphilharmonie/_DSC4828.jpg', 'Elbphilharmonie/AdobeStock_268899014.jpeg'*/ ] },
				{ title: this.$t('r15'), text: this.$t('r15t'), pictures: ['Arabella Sheraton/13a)Arabella Sheraton Hotel in München.jpg', 'Arabella Sheraton/13b)(Arabella Sheraton Hotel in München)Montage der über 500 Gästezimmer.jpg'] },
				{ title: this.$t('r16'), text: this.$t('r16t'), pictures: ['Campeon/12a)Campeon.jpg','Campeon/12b)(Campeon) Einrichtung der gesamten Bereiche.jpg'] },
				{ title: this.$t('r17'), text: this.$t('r17t'), pictures: ['Hofgarten/29a)Hofgarten.jpg','Hofgarten/29b)(Hofgarten)Montage von über 50 Luxuswohnungen.jpg'] },
				{ title: this.$t('r18'), text: this.$t('r18t'), pictures: ['Hotel Kempinski Heiligendamm/31a)Kempinski Hotel Heiligendamm.jpg','Hotel Kempinski Heiligendamm/31b)(Kempinski Hotel Heiligendamm )Möbilierung von über 300 Zimmer.jpg'] },
				{ title: this.$t('r19'), text: this.$t('r19t'), pictures: ['Hotel Kempinski St. Moritz/35a)Kempinski Hotel St. Moritz.jpg','Hotel Kempinski St. Moritz/35b)(Kempinski Hotel St. Moritz)Montage der gesamten Gästezimmer.jpg'] }
			],
			references_nopic: [
				{ title: this.$t('rn01'), text: this.$t('rn01t') },
				{ title: this.$t('rn02'), text: this.$t('rn02t') },
				{ title: this.$t('rn03'), text: this.$t('rn03t') },
				{ title: this.$t('rn04'), text: this.$t('rn04t') },
				{ title: this.$t('rn05'), text: this.$t('rn05t') },
				{ title: this.$t('rn06'), text: this.$t('rn06t') },
				{ title: this.$t('rn07'), text: this.$t('rn07t') },
				{ title: this.$t('rn08'), text: this.$t('rn08t') },
				{ title: this.$t('rn09'), text: this.$t('rn09t') },
				{ title: this.$t('rn11'), text: this.$t('rn11t') },
				{ title: this.$t('rn12'), text: this.$t('rn12t') },
				{ title: this.$t('rn13'), text: this.$t('rn13t') },
				{ title: this.$t('rn14'), text: this.$t('rn14t') },
				{ title: this.$t('rn15'), text: this.$t('rn15t') },
				{ title: this.$t('rn16'), text: this.$t('rn16t') },
				{ title: this.$t('rn17'), text: this.$t('rn17t') },
				{ title: this.$t('rn18'), text: this.$t('rn18t') },
				{ title: this.$t('rn19'), text: this.$t('rn19t') },
				{ title: this.$t('rn20'), text: this.$t('rn20t') },
				{ title: this.$t('rn21'), text: this.$t('rn21t') },
				{ title: this.$t('rn22'), text: this.$t('rn22t') },
				{ title: this.$t('rn23'), text: this.$t('rn23t') },
				{ title: this.$t('rn24'), text: this.$t('rn24t') },
				{ title: this.$t('rn25'), text: this.$t('rn25t') },
				{ title: this.$t('rn26'), text: this.$t('rn26t') },
				{ title: this.$t('rn27'), text: this.$t('rn27t') },
				{ title: this.$t('rn28'), text: this.$t('rn28t') },
				{ title: this.$t('rn29'), text: this.$t('rn29t') },
				{ title: this.$t('rn30'), text: this.$t('rn30t') },
				{ title: this.$t('rn31'), text: this.$t('rn31t') },
				{ title: this.$t('rn32'), text: this.$t('rn32t') },
				{ title: this.$t('rn33'), text: this.$t('rn33t') },
				{ title: this.$t('rn34'), text: this.$t('rn34t') },
				{ title: this.$t('rn35'), text: this.$t('rn35t') },
				{ title: this.$t('rn37'), text: this.$t('rn37t') },
				{ title: this.$t('rn38'), text: this.$t('rn38t') },
				{ title: this.$t('rn40'), text: this.$t('rn40t') },
				{ title: this.$t('rn41'), text: this.$t('rn41t') },
				{ title: this.$t('rn42'), text: this.$t('rn42t') }
			]
		}
	},
	methods: {
		openPicture(pict, copyright, key){
			this.pictures = pict;
			this.copyright = copyright;
			this.selPicIndex = key;
			this.selectedPicture = this.pictures[this.selPicIndex];
			this.overlayVisible = true;
		},
		hidePicture(){
			this.overlayVisible = false;
			this.pictures = null;
			this.copyright = '';
			this.selPicIndex = 0;
			this.selectedPicture = null;
		}
	}
}
</script>
<style>
	.ref-top {
		background-color:white;
		border-top:solid 1px #307bad;
	}
	.ref-bottom {
		border-bottom:solid 1px #307bad;
	}
	.ref-text h5 {
		font-weight:bold;
	}
	.hotspot {
		opacity: 0;
		width:100%;
		height:100%;
		top:0;
		left:0;
		position:absolute;
		background-color: rgba(0,0,0,0.3);
		color:white;
		padding:40px 20px 15px;
		margin-right:15px;
		text-align:left;
		z-index: 5;
		transition: opacity 0.5s ease-in-out;
	}
	.hotspot:hover {
		opacity: 1;
	}
	.overlay-full {
		opacity: 1;
		position: fixed;
		top:0;
		left:0;
		width:100vw;
		height:100vh;
		background-color: rgba(0,0,0,0.7);
		transition: opacity 0.5s ease-in-out;
		z-index: 50;
	}
</style>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
	}
	.image-list img {
		width: 100%;
		height: 100%;
	}  
	.prev-pic {
		min-width:300px;min-height:300px; max-width:100vw;max-height:100vh;border:solid 2px #ccc;cursor:pointer;
	}
	.bg-white {
		background-color:white;
	}
	.bt-gera { 
		border-top:solid 1px #307bad; 
	}
</style>
<i18n>
	{
		"de": {
			"title": "Unsere Referenzen",
			"titleText": "Besonders hochwertige Qualität ist gefragt – und das ohne Frage überall! Unsere Referenzenliste ist lange und auch so vielseitig wie auch unser Handwerk selbst. Nach über 20 Jahren und vielen hunderten Projekten weltweit, finden Sie die einige unserer Sehenswertesten hier aufgelistet.",
			"showbigpic": "großes Bild zeigen",
			"r01": "Haas Haus - Wien", "r01t": "Montage Restaurant Do&Co und ca. 40 Hotelzimmer",
			"r02": "Hotel Mövenpick - Paris", "r02t": "Montage von ca. 300 Zimmern",
			"r03": "Kurfürst Hotel Kempinski - Leipzig", "r03t": "Montage der Zimmer und öffentlichen Bereiche",
			"r04": "Ritz Carlton Hotel - Berlin", "r04t": "Montage von ca. 380 Zimmern",
			"r05": "Schlosshotel - Velden", "r05t": "Montage der Zimmer",
			"r06": "Hotel Dominican - Brüssel", "r06t": "Montage der Zimmer",
			"r07": "NH - Hotel in Frankfurt", "r07t": "Montage der Zimmer",
			"r08": "NH - Hotels in: Wien, Salzburg, Berlin, München, Göttingen, Fürth, Nürnberg, Stuttgart, Düsseldorf, Ludwigsburg", "r08t": " ",
			"r09": "Mercatorhalle - Duisburg", "r09t": "Montage von über 300 Gästezimmern",
			"r10": "Salzburg Kanzleramt - Berlin", "r10t": "Montage der Türen",
			"r11": "Alsenblöcke - Berlin", "r11t": "Montage der Wandverkleidungen in den Sälen, Einbau der gesamten Türen u. Miniarchive in den Büros",
			"r12": "Auswärtige Amt - Berlin", "r12t": "Montage von ca. 800 Büros, der gesamten Ministerbereiche und Flure",
			"r13": "Reichstag - Berlin", "r13t": "Montage der gesamten Wandverkleidungen und Sitzplätze",
			"r14": "Elbphilharmonie - Hamburg", "r14t": "Montage der Pultanlagen",
			"r15": "Arabella Sheraton Hotel in München", "r15t": "Montage der über 500 Gästezimmer",
			"r16": "Hotel Campeon", "r16t": "Einrichtung der gesamten Bereiche",
			"r17": "Hofgarten", "r17t": "Montage von über 50 Luxuswohnungen",
			"r18": "Hotel Kempinski Heiligendamm", "r18t": "Möbilierung von über 300 Zimmern",
			"r19": "Hotel Kempinski St. Moritz", "r19t": "Montage der gesamten Gästezimmer",
			"rn36": "Haus der Musik - Innsbruck", "rn36t": "Montagearbeiten von Atmos-Akustikelementen an Wand und Decke im großen und kleinen Saal.",
			"rn10": "Hotel Kitzhof - Kitzbühel", "rn10t": "Montagearbeiten der 162 Zimmer, Studios und Suiten. Sie bestechen vor allem durch ihr innovatives Design mit viel Altholz, Glas, Loden und modernen Möbeln.",
			"rn39": "Hotel Quellenhof - Bad Ragaz", "rn39t": "Montagearbeiten im prunkvollen und edlen Quellenhof.",
			"r20": "Motel One – Wiener Staatsoper", "r20t": "Montagearbeiten im Foyer und der Lounge. Wenn Klassik auf Moderne trifft und neu interpretiert wird.", "r20c": "Alle Rechte vorbehalten. &copy; 2020 von Motel One",
			"r21": "Motel One – Zürich", "r21t": "Montagearbeiten der Zimmer, des Foyers, an der Bar und der Lounge. Extravaganz in seiner vollendetsten Form.", "r21c": "Alle Rechte vorbehalten. &copy; 2020 von Motel One",
			"r22": "Luxusyachten", "r22t": "Einbau von Schiffsausstattung auf 6 der 10 größten Luxusyachten der Welt",

			"rn01": "Astron Hotels in: München, Köln, Zürch, Hamburg, Heidelberg, Frankfurt, Düsseldorf, Budapest, Kitzbühel, Wien", "rn01t": "Montage Zimmer & öffentlichen Bereiche",
			"rn02": "K & K Hotels: London, München, Wien, Budapest", "rn02t": "Montage Zimmer",
			"rn03": "Sofitel Uniqa - Wien", "rn03t": "Montage Zimmer & öffentlichen Bereiche",
			"rn04": "Penta Hotels in: Berlin, Leipzig, Braunschwaig, Wiesbaden, Rostock, Reading, Eisenach,Paris, Kassel, Brüssel", "rn04t": "Montage Zimmer",
			"rn05": "Grandhotel - Lienz", "rn05t": "Öffentlicher Bereich",
			"rn06": "Hotel in Dubrovnik", "rn06t": "Montage Zimmer",
			"rn07": "Hotel Weitzer Graz", "rn07t": "Montage Zimmer",
			"rn08": "Hotel Flamingo Bulgarien", "rn08t": "Montage Zimmer",
			"rn09": "Ritz Carlton Hotel - Dublin", "rn09t": "'Montage Zimmer & öffentlichenn Bereiche",
			"rn11": "Hotel Reiters - Bad Tatzmannsdorf", "rn11t": "Montage Zimmer",
			"rn12": "Hotel Jumeirah - Mallorca", "rn12t": "Montage Zimmer",
			"rn13": "The Hotel - Brüssel", "rn13t": "Montage Zimmer",
			"rn14": "BMF - Wien", "rn14t": "Montage Büroeinrichtungen, Wandverkleidungen, Türen etc.",
			"rn15": "BBI Flughafen - Berlin", "rn15t": "Montage von Wandverkleidungen",
			"rn16": "Staatstheater - Stuttgart", "rn16t": "Montage der Deckenverkleidung & Türen",
			"rn17": "Skylink - Flughafen - Wien", "rn17t": "Montage von Pulten und Wandverkeleidungen",
			"rn18": "Staatsbibliothek - Berlin", "rn18t": "Schrankverbauten",
			"rn19": "Regierungsgebäude - Ufa", "rn19t": "Montage von Wandverkleidungen",
			"rn20": "Uniqa Tower - Wien", "rn20t": "Montage von Wandverkleidungen",
			"rn21": "DC Tower - Wien", "rn21t": "Montage der Wand- Deckenverkleidung & Türen",
			"rn22": "Luxusvillen in Ibiza und Liechtenstein", "rn22t": "Montage der gesamten Möbilierung",
			"rn23": "Casino in: Linz, Graz, Wien, Bregenz", "rn23t": "Montage aller Bereiche",
			"rn24": "Villa Anna - Moskau", "rn24t": "Montage aller Möbel",
			"rn25": "Mercartorhalle - Duisburg", "rn25t": "Montage Wand- Deckenverkleidungen + Türen",
			"rn26": "Hotel Steigenberger - Köln", "rn26t": "Montage der gesamten Zimmereinrichtung",
			"rn27": "Hotel Hyatt - Köln", "rn27t": "Montage öffentl. Bereich",
			"rn28": "Hotel Mandarin - München", "rn28t": "Montage öffentl. Bereich",
			"rn29": "Hyatt Hotel - Amsterdam", "rn29t": "Montage Zimmer + öffentl. Bereich",
			"rn30": "Motel One Hotel: Zürich, München, Salzburg, Linz", "rn30t": "Montage Zimmer + öffentl. Bereich",
			"rn31": "Hotel Kempinski - München", "rn31t": "Montage der gesamten Zimmereinrichtung",
			"rn32": "Agora Resort - Louvain la Neuve'", "rn32t": "Montage der gesamten Zimmereinrichtung",
			"rn33": "Hotel Holiday Inn - Nürnberg", "rn33t": "Montage der gesamten Zimmereinrichtung",
			"rn34": "Jufa Hotel - Hamburg", "rn34t": "Montage der gesamten Zimmereinrichtung",
			"rn35": "Hotel Fürstenhof", "rn35t": "Montage von über 100 Gästezimmer",
			"rn37": "Justitzgebäude - Salzburg", "rn37t": "Monatge der Türelemente",
			"rn38": "Hotel Sacher - Wien u. Salzburg", "rn38t": "Montage Zimmereinrichtungen und Suiten",
			"rn40": "Hotel New York - Paris", "rn40t": "Montage Zimmereinrichtungen und Suiten",
			"rn41": "Konzerthaus Radio France - Paris", "rn41t": "Montage Wand- Deckenverkleidungen + Türen",
			"rn42": "Hotel Kitzhof - Kitzbühel", "rn42t": "Montage Zimmereinrichtungen und Suiten"
		},
		"en": {
			"title": "Our references",
			"titleText": "An especially high degree of quality is necessary in everything we do! Our reference list is long and is as diversified as our trade is. You can find a list of some of our most outstanding projects worldwide after over 20 years in the business and many hundred projects around the globe.",
			"showbigpic": "show big picture",
			"r01": "Haas Haus – Vienna", "r01t": "Installation of Do&Co Restaurant and approximately 40 hotel rooms",
			"r02": "Hotel Mövenpick in Paris", "r02t": "Installation of approximately 300 rooms",
			"r03": "Kurfürst Hotel Kempinski in Leipzig", "r03t": "Installation of rooms and public areas",
			"r04": "Ritz Carlton Hotel in Berlin", "r04t": "Installation of approximately 380 rooms",
			"r05": "Schlosshotel in Velden", "r05t": "Rooms installation",
			"r06": "Hotel Dominican in Brussels", "r06t": "Installation of rooms & public areas",
			"r07": "NH - Hotel in Frankfurt", "r07t": "Installation of rooms & public areas",
			"r08": "NH - Hotels in: Vienna, Salzburg, Berlin, Munich, Göttingen, Fürth, Nuremberg, Stuttgart, Dusseldorf, Ludwigsburg", "r08t": "Installation of over 300 guest rooms",
			"r09": "Mercatorhalle in Duisburg", "r09t": "Installation of wallcoverings",
			"r10": "Salzburg Chancellor Office in Berlin", "r10t": "Installation of doors",
			"r11": "Alsenblöcke (government building) in Berlin", "r11t": "Installation of wallcoverings in halls and installation of all doors and mini-archives in offices",
			"r12": "Foreign Office in Berlin", "r12t": "Installation of approximately 800 offices, the entire minister areas and halls",
			"r13": "Reichstag in Berlin", "r13t": "Installation of all wallcoverings and seats",
			"r14": "Elbphilharmonie in Hamburg", "r14t": "Installation of the conductor’s stands",
			"r15": "Arabella Sheraton Hotel in Munich", "r15t": "Installation of 500 guest rooms",
			"r16": "Hotel Campeon", "r16t": "Installation of all areas",
			"r17": "Hofgarten", "r17t": "Installation of over 50 luxury dwellings",
			"r18": "Hotel Kempinski Heiligendamm", "r18t": "Furnishing of over 300 rooms",
			"r19": "Hotel Kempinski St. Moritz", "r19t": "Installation of all guestrooms",
			"rn36": "Haus der Musik in Innsbruck", "rn36t": "Installation of wall and ceiling coverings + doors",
			"rn10": "Hotel Kitzhof in Kitzbühel", "rn10t": "Installation of rooms",
			"rn39": "Hotel Quellenhof in Bad Ragaz", "rn39t": "Installation of public area",
			"r20": "Motel One – Wiener Staatsoper", "r20t": "Montagearbeiten im Foyer und der Lounge. Wenn Klassik auf Moderne trifft und neu interpretiert wird.", "r20c": "All rights reserved. &copy; 2020 by Motel One",
			"r21": "Motel One – Zürich", "r21t": "Montagearbeiten der Zimmer, des Foyers, an der Bar und der Lounge. Extravaganz in seiner vollendetsten Form.", "r21c": "All rights reserved. &copy; 2020 by Motel One",
			"r22": "Luxury yachts", "r22t": "Installation of ship equipment on 6 of the 10 largest luxury yachts in the world",

			"rn01": "Astron Hotels in: Munich, Cologne, Zurich, Hamburg, Heidelberg, Frankfurt, Dusseldorf, Budapest, Kitzbühel, Vienna", "rn01t": "Installation of rooms & public areas",
			"rn02": "K & K Hotels: London, Munich, Vienna, Budapest", "rn02t": "Installation of rooms",
			"rn03": "Sofitel Uniqa in Vienna", "rn03t": "Installation of rooms & public areas",
			"rn04": "Penta Hotels in: Berlin, Leipzig, Braunschweig, Wiesbaden, Rostock, Reading, Eisenach, Paris, Kassel, Brussels", "rn04t": "Installation of rooms",
			"rn05": "Grandhotel in Lienz", "rn05t": "Public area",
			"rn06": "Hotel in Dubrovnik", "rn06t": "Installation of rooms",
			"rn07": "Hotel Weitzer in Graz", "rn07t": "Installation of rooms",
			"rn08": "Hotel Flamingo in Bulgaria", "rn08t": "Installation of rooms",
			"rn09": "Ritz Carlton Hotel in Dublin", "rn09t": "Installation of rooms & public areas",
			"rn11": "Hotel Reiters in Bad Tatzmannsdorf", "rn11t": "Installation of rooms",
			"rn12": "Hotel Jumeirah in Mallorca", "rn12t": "Installation of rooms",
			"rn13": "“The Hotel” in Brussels", "rn13t": "Installation of rooms",
			"rn14": "BMF in Vienna", "rn14t": "Installation of office furnishings, wallcoverings, doors etc.",
			"rn15": "BBI Airport in Berlin", "rn15t": "Installation of wallcoverings",
			"rn16": "Staatstheater in Stuttgart", "rn16t": "Installation of ceiling coverings & doors",
			"rn17": "Skylink at Vienna Airport", "rn17t": "Installation of counters and wall coverings",
			"rn18": "Staatsbibliothek (national library) in Berlin", "rn18t": "Cabinet installations",
			"rn19": "Government building in Ufa", "rn19t": "Installation of wallcoverings",
			"rn20": "Uniqa Tower in Vienna", "rn20t": "Installation of wallcoverings",
			"rn21": "DC Tower in Vienna", "rn21t": "Installation of wall and ceiling coverings & doors",
			"rn22": "Luxury villas in Ibiza and Liechtenstein", "rn22t": "Installation of all furnishings",
			"rn23": "Casino in: Linz, Graz, Vienna, Bregenz", "rn23t": "Installation of all areas",
			"rn24": "Villa Anna in Moskau", "rn24t": "Installation of all furniture",
			"rn25": "Mercartorhalle in Duisburg", "rn25t": "Installation of wall and ceiling coverings + doors",
			"rn26": "Hotel Steigenberger in Cologne", "rn26t": "Installation of entire room furnishings",
			"rn27": "Hotel Hyatt in Cologne", "rn27t": "Installation of public area",
			"rn28": "Hotel Mandarin in Munich", "rn28t": "Installation of public area",
			"rn29": "Hyatt Hotel in Amsterdam", "rn29t": "Installation of rooms + public area",
			"rn30": "Motel One Hotel: Zurich, Munich, Salzburg, Linz", "rn30t": "Installation of rooms + public area",
			"rn31": "Hotel Kempinski in Munich", "rn31t": "Installation of entire room furnishings",
			"rn32": "Agora Resort in Louvain la Neuve'", "rn32t": "Installation of entire room furnishings",
			"rn33": "Hotel Holiday Inn in Nuremberg", "rn33t": "Installation of entire room furnishings",
			"rn34": "Jufa Hotel in Hamburg", "rn34t": "Installation of entire room furnishings",
			"rn35": "Hotel Fürstenhof", "rn35t": "Installation of over 100 guestrooms",
			"rn37": "Salzburg Courthouse", "rn37t": "Installation of door units",
			"rn38": "Hotel Sacher in Vienna and Salzburg", "rn38t": "Installation of room furnishings and suites",
			"rn40": "Hotel New York in Paris", "rn40t": "Installation of room furnishings and suites",
			"rn41": "Radio France conference house in Paris", "rn41t": "Installation of wall and ceiling coverings + doors",
			"rn42": "Hotel Kitzhof - Kitzbühel", "rn42t": "Installation of room furnishings and suites"
		}
	}
</i18n>
